require('./submit-readings');

document.addEventListener('DOMContentLoaded', function () {

    var hash = window.location.hash.substring(1);

    if (hash)
    {
        $('#' + hash).addClass('hash-selected');
    }

    // get the estimated costs when table tab is clicked
    $('.costs input#elec_table, .costs input#gas_table').click(function (event) {
        // advance data already loaded earlier?
        if (advance_calculated)
        {
            return;
        }

        // for now, we don't want to load the future prices when clicking the tab
        return;

        event.stopPropagation();
        var params = new URLSearchParams(window.location.search);
        var target = event.target;

        if (((target.id === 'elec_table') || (target.id === 'gas_table')) && (params.get('future') !== '1'))
        {
            hash = ((target.id === 'elec_table') ? 'elec_anchor' : 'gas_anchor');

            params.set('future', '1');
            params.set('future_analysis', '1');

            window.location.href = location.protocol + '//' + location.host + location.pathname +
                '?' + params.toString() + (hash ? '#' + hash : '');
        }
    });

    $('.segmented-control-tabs .segment').on('click', function () {
        // Remove active class from all segments
        $(this).siblings().removeClass('active');
        // Add active class to the clicked button
        $(this).addClass('active');

        // If the clicked tab is 'gas', hide the .cheapest-moment element
        if ($(this).data('tab') === 'gas') {
            $('.cheapest-moment').hide();
        } else {
            $('.cheapest-moment').show();
        }

        // Get the tab ID from the clicked button
        const tabId = $(this).data('tab');

        $(this).closest('.tabs-container').find('.tab-content').each(function () {
            $(this).toggleClass('active', this.id === 'tab-' + tabId);
        });
    });

    $('.segmented-control-tabs .segment.active').trigger('click')
});
